<template>
  <div
    class="TransactionList">
    <TransactionCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadCRUDList"
    />
    <GLModesExpandableComponent
      :baseCrudKey="baseCrudKey"
    />
    <CRUDList
      :canAdd="true"
      :canEdit="true"
      :canApply="true"
      :canSave="false"
      :headers="headers"
      :showSelect="true"
      :showDate="true"
      :showTotal="true"
      :createNewItem="newItemDialog"
      overrideApplyBtnLabel="SAVE"
      :baseCrudKey="baseCrudKey"
      :selectedItems="selectedItems"
      toolbarTitle="General Ledger"
      @loadCRUDList="handleLoadCRUDList"
      @upsertItem="upsertTransaction"
      @emitSelectedItem="emitSelectedItem"
      :enableFixedHeaders="true"
      tableDynamicHeight="400"
    >
      <template v-slot:[`editedItem`]="{}">
        <TransactionEditedItem
          :baseCrudKey="baseCrudKey"
          @activeItem="activeItem"
        />
      </template>
      <template v-slot:[`additionalActions`]="{}">
        <AuditDialog
          v-if="getActiveTransID"
          :identifier="getActiveTransID"
          activatorCaption="Audit History"
        />
      </template>
      <template v-slot:[`canDeleteSlot`]="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon id="glTransListDeleteIcon"
              class="mx-2 gl-translist-delete-icon" color="primary"
              fab icon small
              v-bind="attrs"
              v-on="on"
              :disabled="(selectedItems || []).length === 0"
              @click="deleteItems"
            >
              {{icons.mdiDelete}}
            </v-icon>
          </template>
            <span>Delete</span>
        </v-tooltip>
         <v-divider
          class="mx-4" inset vertical
        ></v-divider>
      </template>
      <template v-slot:[`additionalToolsAtRight`]="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="glDailyTranLisTLockBtn"
              class="glDaily-translist-lock-icon"
              color="primary"
              v-bind="attrs"
              v-on="on"
              fab icon small
              @click="lockRecords"
            >
              <v-icon>
                {{ icons.mdiLockOutline }}
              </v-icon>
            </v-btn>
          </template>
          <span>Lock</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              id="glDailyTranListUnlockBtn"
              class="glDaily-translist-unlock-icon"
              color="primary"
              fab icon small
              :disabled="isUnlocked"
              @click="unlockRecords"
            >
              <v-icon>
                {{ icons.mdiLockOpenVariantOutline }}
              </v-icon>
            </v-btn>
          </template>
          <span>Unlock</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <ReportInfo
              v-if="forceReloadDetails"
              :reportType="reportType"
              :closeDialogBox="closeDialogBox"
              :businessDate="(criteriaState || {}).businessDate || ''"
              :fiscalYear="(criteriaState || '').fiscalYear || ''"
              @settingDialogVal="settingDialogVal"
            />
          <v-btn
            id="glDailyTranListPrintReceiptBtn"
            class="glDaily-translist-print-receipt-icon"
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="openComponent('glDaily')"
          >
          <v-icon left>
            {{ icons.mdiPrinter }}
          </v-icon>
          Print GL
          </v-btn>
          </template>
            <span>Print GL</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            id="glDailyTranListPrintReceiptBtn"
            class="glDaily-translist-print-receipt-icon"
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="openReport"
          >
          <v-icon left>
            {{ icons.mdiPrinter }}
          </v-icon>
          Print Daily
          </v-btn>
          </template>
            <span>Print Daily</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            id="glDailyTranListPrintReceiptBtn"
            class="glDaily-translist-print-receipt-icon"
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="openComponent('journalEntry')"
          >
          <v-icon left>
            {{ icons.mdiPrinter }}
          </v-icon>
          Journal Entry Report
          </v-btn>
          </template>
            <span>Journal Entry Report</span>
        </v-tooltip>
      </template>
    </CRUDList>
    <v-dialog
      v-model="glTransAdditionalDialogBox"
      persistent
      width="50vw"
      height="140vh">
    <v-card>
      <v-card-title>
        <span class="headline"> {{ this.glTransAdditionalDialog.headerText }}</span>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary"
          text @click="glTransAdditionalDialogAction(true)">
           {{ this.glTransAdditionalDialog.btnOneText }}
        </v-btn>
        <v-btn color="primary"
          text @click="glTransAdditionalDialogAction(false)">
          {{ this.glTransAdditionalDialog.btnTwoText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
    <div class="snackbar-gl-expandable-component">
      <v-snackbar
        v-model="snackbar"
        color="primary"
        :timeout="-1"
      >
        <GLExpandableComponent
          :baseCrudKey="baseCrudKey"
        />
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions,
  mapState,
} from 'vuex';
import {
  mdiPrinter,
  mdiLockOutline,
  mdiLockOpenVariantOutline,
  mdiDelete,
} from '@mdi/js';
import TransactionCriteria from './TransactionCriteria.vue';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import TransactionEditedItem from './TransactionEditedItem.vue';
import {
  amountFormat,
  amountToNumber,
  checkStringEmptiness,
  extractId,
  camelCaseEachToWords,
} from '../../../util/shared/vue-global';
import { updateDateFormat, toFiscalYear, toIsoDate } from '../../../util/shared/tmc-global';
import { getRawJwt } from '../../../util/jwt';
import { queryStringCalcForDailyGL } from './report-util';
import { clients } from '../../../util/clients';
import { glLockUnlockOperations, glTaggedTransactionEnums } from './gl-transaction.util';
import ReportInfo from './ReportInfo.vue';
import GLExpandableComponent from './GLExpandableComponent.vue';
import GLModesExpandableComponent from './GLModesExpandableComponent.vue';
import AuditDialog from '../../common/audit/AuditDialog.vue';
import { isJournalEntriesOrTransfers, isBudgetedFundOrCashFund } from '../../shared/shared.util';
import { printerHandler } from '../../../util/pdf-to-printer.util';

const { backendRest } = clients.direct;

const formatAmountOrNull = (val) => {
  /*
    note: doing amountFormat on val first since val can be '-3.637978807091713e-12' or null or 0
  */
  const formatAmount = amountFormat(val);
  const amount = ((formatAmount === '0.00') ? null : formatAmount);
  return amount;
};

const getHeaders = () => {
  const headers = [
    { text: 'Fund/Bank', value: 'fundOrBank' },
    // { text: 'Line', value: '' },
    // { text: 'Fund', value: 'fund.fund' },
    // { text: 'Bank', value: 'bank.altKeyBase' },
    { text: 'Description', value: 'description' },
    { text: 'Alt Key', value: 'altKey' },
    {
      text: 'Sec', value: 'dailySection', formatter: 'getFirstChar', sortable: false,
    },
    { text: 'From', value: 'fromNumber' },
    { text: 'To', value: 'toNumber' },
    {
      text: 'Deposit',
      value: 'deposit',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Transfer In',
      value: 'transferIn',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Transfer Out',
      value: 'transferOut',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Payments',
      value: 'payments',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    // { text: 'J/T', value: '' }, => this isn't in our DB?
    { text: 'Locked', value: 'isLocked', formatter: 'boolToStr' },
  ];
  return headers;
};

/* glDailyTransactions may be an array or object. */
const postProccess = (glDailyTransactions) => {
  const buildFundOrBank = (t) => {
    let fundOrBank = '';
    if (t.fund) {
      const fundNumber = t.fund.fund || '';
      const fundDescription = t.fund.description || '';
      fundOrBank = t.fund.fund === '0000' ? fundDescription : `${fundNumber} - ${fundDescription}`;
    } else if (t.bank) {
      const bankAltKeyBase = t.bank.altKeyBase || '';
      const bankName = t.bank.bankName || '';
      fundOrBank = `${bankAltKeyBase} - ${bankName}`;
    }
    return fundOrBank;
  };

  const buildFundOrBankAltKey = (t) => {
    let altKey = '';
    if (t.fund) {
      altKey = t.fund.altKey || '';
    } else if (t.bank) {
      altKey = t.bank.altKeyBase || '';
    }
    return altKey;
  };

  const buildPostProcessData = (transaction) => ({
    ...transaction,
    fundOrBank: buildFundOrBank(transaction),
    altKey: buildFundOrBankAltKey(transaction),
    description: camelCaseEachToWords(transaction.description),

  });

  let processedData;
  if (Array.isArray(glDailyTransactions)) {
    const newArray = [...glDailyTransactions];
    processedData = newArray.map((transaction) => {
      const updatedTransaction = { ...transaction };
      const cssProp = ['orange', 'accent-1'];
      if (
        glTaggedTransactionEnums().includes(updatedTransaction.tag)
        && !updatedTransaction.isVerified
      ) {
        updatedTransaction.crudRowCssAppend = cssProp;
      }
      return buildPostProcessData(updatedTransaction);
    });
  } else {
    const updatedTransaction = { ...glDailyTransactions };
    const cssProp = ['orange', 'accent-1'];
    if (
      glTaggedTransactionEnums().includes(updatedTransaction.tag)
      && !updatedTransaction.isVerified
    ) {
      updatedTransaction.crudRowCssAppend = cssProp;
    }
    processedData = buildPostProcessData(updatedTransaction);
  }
  return processedData;
};

export default {
  data: () => ({
    baseCrudKey: 'glDailyTransaction',
    reportType: '',
    headers: [],
    dateForCriteria: ['businessDate'],
    activeTransItem: undefined,
    closeDialogBox: false,
    forceReloadDetails: false,
    warTransItem: {},
    glTransAdditionalDialogBox: false,
    glTransAdditionalDialog: {
      headerText: '',
      btnOneText: 'YES',
      btnTwoText: 'NO',
      showCancelBtn: false,
    },
    icons: {
      mdiPrinter,
      mdiLockOutline,
      mdiLockOpenVariantOutline,
      mdiDelete,
    },
    snackbar: true,
    saveable: true,
  }),
  created() {
    this.headers = getHeaders();
    this.initCriteria();
    this.loadLists();
  },
  components: {
    CRUDList,
    TransactionCriteria,
    TransactionEditedItem,
    ReportInfo,
    GLExpandableComponent,
    GLModesExpandableComponent,
    AuditDialog,
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
      'items',
      'isVisible',
    ]),
    ...mapState({
      storedSelectedItems: (state) => state.glDaily.glDailyTransaction.selectedItems,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    selectedItems: {
      get() {
        return this.storedSelectedItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    queryString() {
      return queryStringCalcForDailyGL({
        criteria: this.criteriaState,
        token: this.getAuthToken,
      });
    },
    getAuthToken() {
      return getRawJwt();
    },
    isUnlocked() {
      for (let i = 0; i < (this.selectedItems || []).length; i += 1) {
        if (this.selectedItems[i].isLocked) {
          return false;
        }
      }
      return true;
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
  },
  methods: {
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions(['flashInfo', 'flashSuccess']),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setIsVisible',
    ]),
    ...mapActions('glDaily/glDailyTransaction', [
      'loadGlDailyTransaction',
      'upsertGlDailyTrans',
      'loadGLBalance',
      'glLockUnlockTransaction',
      'deleteGlDailyTransaction',
    ]),
    ...mapMutations('glDaily/glDailyTransaction', [
      'setSelectedItems',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    // war map
    ...mapActions('war/transaction', [
      'upsrtTransaction',
    ]),
    handleLoadCRUDList(criteriaArgs = {}) {
      const { baseCrudKey } = this;
      const criteria = this.updateCriteriaForReq();
      if (criteriaArgs.searchMode) {
        criteria.businessDate = null;
      }
      this.loadGlDailyTransaction({ criteria, baseCrudKey, postProccess }).then(() => {
        this.setDefaultSelectedItems();
      });
    },
    updateCriteriaForReq() {
      const updatedCriteria = updateDateFormat(this.criteriaState, this.dateForCriteria);
      return updatedCriteria;
    },
    emitSelectedItem(item) {
      this.selectedItems = item;
    },
    isWarRecord(updatedItem, fundObj) {
      if (updatedItem._id === undefined
        && isJournalEntriesOrTransfers(updatedItem.dailySection)
        && isBudgetedFundOrCashFund(fundObj.type)) {
        return true;
      }
      return false;
    },
    glTransDailogBox() {
      this.glTransAdditionalDialogBox = true;
      this.glTransAdditionalDialog.showCancelBtn = true;
      this.glTransAdditionalDialog.headerText = 'Would you like to add an Appropriation Ledger record for this transfer ?';
      this.glTransAdditionalDialog.btnOneText = 'YES ';
      this.glTransAdditionalDialog.btnTwoText = 'NO ';
    },

    async glTransAdditionalDialogAction(isResponseFlag) {
      this.glTransAdditionalDialogBox = false;
      this.glTransAdditionalDialog.headerText = '';
      this.glTransAdditionalDialog.showCancelBtn = false;
      if (isResponseFlag) {
        const amount = (this.warTransItem.transferIn - this.warTransItem.transferOut);
        const updatedWarItem = {
          registerDate: this.warTransItem.businessDate,
          fiscalYear: this.warTransItem.fiscalYear,
          issueDate: this.warTransItem.businessDate,
          paidCancelledDate: null,
          amount,
          whomStr: 'transfer',
          type: 'TRANSFERS',
          purchaseOrder: null,
          details: [
            {
              fund: this.warTransItem.fund._id,
              department: null,
              account: null,
              amount,
            },
          ],
        };
        await this.upsrtTransaction({ item: updatedWarItem, baseCrudKey: 'warTransaction' }).then(() => {
          this.flashSuccess('Transfer transaction is Successfully saved!');
        });
      }
    },

    async upsertTransaction(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      const fundArr = this.items('sharedFund');
      const fundObj = fundArr.find((fundItem) => fundItem._id === item.fund);
      const glConfig = await this.loadConfig({ requiredScope: 'glConfig' });
      const appLedgerTransfer = ((glConfig || [])[0].configuration.appLedgerTransfer || false);
      // need to refactor this
      delete updatedItem.crudRowCssAppend;
      updatedItem.order = amountToNumber(updatedItem.order);
      updatedItem.fromNumber = amountToNumber(updatedItem.fromNumber);
      updatedItem.toNumber = amountToNumber(updatedItem.toNumber);
      updatedItem.deposit = amountToNumber(updatedItem.deposit);
      updatedItem.transferIn = amountToNumber(updatedItem.transferIn);
      updatedItem.transferOut = amountToNumber(updatedItem.transferOut);
      updatedItem.payments = amountToNumber(updatedItem.payments);
      if (updatedItem.dailySection === 'DEPOSITSANDCHECKS') {
        updatedItem.fund = null;
      }
      if (updatedItem.dailySection === 'COLLECTIONS') {
        updatedItem.bank = null;
      }
      if (updatedItem.dailySection === 'PAYMENTS') {
        updatedItem.deposit = null;
        updatedItem.transferIn = null;
        updatedItem.transferOut = null;
      }
      if (updatedItem.bank) {
        updatedItem.bank = extractId(updatedItem.bank);
      }
      if (updatedItem.fund) {
        updatedItem.fund = extractId(updatedItem.fund);
      }
      /* delete additional fields */
      delete updatedItem.fundOrBank;
      delete updatedItem.altKey;
      if (updatedItem.bank == null && updatedItem.fund == null) {
        const bankOrFund = window.confirm('Please select  fund or bank it will not save record !');
        if (bankOrFund || !bankOrFund) {
          return this.setIsVisible([this.baseCrudKey, true]);
        }
        return null;
      }
      const response = await this.upsertGlDailyTrans({
        item: updatedItem,
        baseCrudKey,
        postProccess,
      });
      if (Object.keys(response).length > 0) {
        if (
          updatedItem.bank == null
          && this.isWarRecord(updatedItem, fundObj)
          && appLedgerTransfer
        ) {
          this.glTransDailogBox();
          this.warTransItem = response;
        }
        this.selectedItems = [];
        this.setIsVisible([this.baseCrudKey, false]);
        await this.loadGLBalanceList();
      }
      return response;
    },
    async loadBankList() {
      const bankList = await this.loadBanks({
        criteria: {},
        baseCrudKey: 'sharedBank',
      });
      return bankList;
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        businessDate: this.criteriaState.businessDate || this.todaysDate,
        fiscalYear: toFiscalYear(new Date(this.criteriaState.businessDate || this.todaysDate)),
        dailySection: null,
        bank: null,
        fund: null,
      };
      if (this.criteriaState.dailySection !== null
      && this.criteriaState.dailySection !== undefined) {
        newItem.dailySection = this.criteriaState.dailySection;
      }
      return newItem;
    },
    loadFundsList() {
      this.loadFunds({
        criteria: {
          fiscalYear: toFiscalYear(new Date(this.todaysDate)),
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: 'sharedFund',
      });
    },
    initCriteria() {
      this.criteriaState = {};
      this.criteriaState.businessDate = this.todaysDate;
      this.criteriaState.fiscalYear = toFiscalYear(new Date(this.todaysDate));
    },
    async loadGLBalanceList() {
      if (this.criteriaState.fiscalYear != null
      && !checkStringEmptiness(this.criteriaState.businessDate)) {
        await this.loadGLBalance({
          criteria: {
            fiscalYear: this.criteriaState.fiscalYear,
            businessDate: toIsoDate(this.criteriaState.businessDate),
            skipApprortionment: false,
          },
        });
      }
    },
    loadLists() {
      this.loadConfig({ requiredScope: 'glConfig' });
      this.loadBankList();
      this.loadFundsList();
      this.loadGLBalanceList();
    },
    openComponent(val) {
      this.reportType = val;
      this.closeDialogBox = true;
      this.forceReloadDetails = true;
    },
    settingDialogVal(value) {
      this.closeDialogBox = value;
      this.forceReloadDetails = false;
    },
    openReport() {
      const toUrl = `${backendRest.defaults.baseURL}/gl/transaction/dailyGL${this.queryString}`;
      // window.open(toUrl);
      printerHandler(this, { url: toUrl });
    },
    selectedItemsIDs() {
      const arrayOfIds = [];
      for (let i = 0; i < (this.selectedItems || []).length; i += 1) {
        arrayOfIds.push(this.selectedItems[i]._id);
      }
      return arrayOfIds;
    },
    async lockRecords() {
      if ((this.selectedItems || []).length === 0) {
        if (window.confirm(`This will lock all the record/s for the date ${this.criteriaState.businessDate}!`)) {
          await this.lockByDateAndFy(
            this.criteriaState.fiscalYear,
            this.criteriaState.businessDate,
          );
          this.handleLoadCRUDList();
          this.flashSuccess('All the records are now successfully locked!');
        }
      } else if (window.confirm(`This will lock the ${(this.selectedItems || []).length} selected record/s!`)) {
        await this.lockUnlockByIds(glLockUnlockOperations().lockByIds);
        this.handleLoadCRUDList();
        this.flashSuccess('All the records are now successfully locked!');
      } else {
        this.selectedItems = [];
      }
    },

    async lockByDateAndFy(fiscalYear, businessDate) {
      await this.glLockUnlockTransaction({
        criteria: {
          fiscalYear,
          businessDate: toIsoDate(businessDate),
          operation: glLockUnlockOperations().lockByDateAndFy,
        },
      });
    },

    async lockUnlockByIds(operation) {
      const selectedIds = this.selectedItemsIDs();
      await this.glLockUnlockTransaction({
        criteria: {
          _ids: selectedIds || [],
          operation,
        },
      });
    },

    async unlockRecords() {
      if (window.confirm(`This will unlock the ${(this.selectedItems || []).length} selected record/s!`)) {
        await this.lockUnlockByIds(glLockUnlockOperations().unlockByIds);
        this.handleLoadCRUDList();
        this.flashSuccess('All the records are now successfully unlocked!');
      } else {
        this.selectedItems = [];
      }
    },
    activeItem(item) {
      if (item.isLocked === true) {
        this.saveable = false;
        return this.saveable;
      }
      this.saveable = true;
      this.activeTransItem = item;
      return this.saveable;
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    async deleteTransaction(item) {
      const { baseCrudKey } = this;
      await this.deleteGlDailyTransaction({ item, baseCrudKey }).then(() => {
        this.setDefaultSelectedItems();
      }).catch((e) => {
        console.warn(e);
        this.setDefaultSelectedItems();
      });
    },
    async deleteItems() {
      if (window.confirm(`CAREFUL! Are you sure you want to DELETE ${this.selectedItems.length} record/s?`)) {
        for (let i = 0; i < (this.selectedItems || []).length; i += 1) {
          const item = this.selectedItems[i];
          this.deleteTransaction(item);
        }
      }
      this.selectedItems = [];
      await this.loadGLBalanceList();
    },
  },
};
</script>

<style lang="sass">
.snackbar-gl-expandable-component
  .v-snack__wrapper
    max-width: 100%
    width: 100%
  .v-snack__content
    padding: 0 0 0 0
  .v-expansion-panel-header
    min-height: 0

</style>
